//  [REDUCER][TYPE]
import { IReduxType, typeCreatorV2 } from '../../utils/common';
export const SET_MEMBER_STATE: string = typeCreatorV2(
  'RequestReducer',
  'SetMemberStateCountries'
);

export const SET_ALL_COUNTRIES: string = typeCreatorV2(
  'RequestReducer',
  'SetAllCountries'
);

export const SET_REGISTRATION_REQUEST: string = typeCreatorV2(
  'RequestReducer',
  'SetRegistrationRequest'
);

export const SET_VATRETURN_REQUEST: string = typeCreatorV2(
  'RequestReducer',
  'SetVatReturnRequest'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'RequestReducer',
  'SetMemberStateCountriesExcludeCyprus'
);
